import { createAsyncAction } from 'typesafe-actions';
import { ExternalAuthPayload, UserLoginResponse } from './types';

export const externalLogin = createAsyncAction(
  'user/EXTERNAL_LOGIN_REQUEST',
  'user/EXTERNAL_LOGIN_RESPONSE',
  'user/EXTERNAL_LOGIN_FAILURE',
)<ExternalAuthPayload, UserLoginResponse, Error>();

export const getCurrentUser = createAsyncAction(
  'user/GET_CURRENT_REQUEST',
  'user/GET_CURRENT_RESPONSE',
  'user/GET_CURRENT_FAILURE',
)<void, Pick<UserLoginResponse, 'user'>, Error>();
